import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { cartLineCardCondensedStyles } from "@insite/content-library/Widgets/Cart/CartLineCardCondensed";
import { css } from "styled-components";

cartLineCardCondensedStyles.productPrice = mergeToNew(cartLineCardCondensedStyles.productPrice, {
    priceLabelText: {
        size: 14,
    },
});

cartLineCardCondensedStyles.productPriceAndAvailabilityGridItem = mergeToNew(
    cartLineCardCondensedStyles.productPriceAndAvailabilityGridItem,
    {
        width: 12,
    },
);

cartLineCardCondensedStyles.quantityGridItem = mergeToNew(cartLineCardCondensedStyles.quantityGridItem, {
    width: 12,
    css: css`
        padding-top: 0px;
    `,
});

cartLineCardCondensedStyles.quantity = mergeToNew(cartLineCardCondensedStyles.quantity, {
    editableQuantityTextField: {
        css: css`
            max-width: 100px;
            border-radius: 6px !important;
        `,
    },
});
